import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Forms/Register.css";
import Navigation from "../Components/Navigation/Navigation";
import Footer from "../Components/Navigation/Footer";
import locationsData from "../Forms/locations.json";
import Banner from "../Components/Banner";
import EstateBuilding from "../Assets/Images/Banner/register.jpg";

function Register() {
  const [locations, setLocations] = useState([]);
  const [valuationType, setValuationType] = useState("");

  useEffect(() => {
    document.title = "Register With Us | Zen Homes";
    const initialLocations = locationsData.map((name) => ({
      name,
      selected: false,
    }));
    setLocations(initialLocations);
  }, []);

  const selectAllLocations = () => {
    setLocations(locations.map((loc) => ({ ...loc, selected: true })));
  };

  const handleLocationChange = (index) => {
    const updatedLocations = [...locations];
    updatedLocations[index].selected = !updatedLocations[index].selected;
    setLocations(updatedLocations);
  };

  const API_KEYS = {
    sales: process.env.REACT_APP_SALES_API_KEY,
    lettings: process.env.REACT_APP_LETTINGS_API_KEY,
  };

  const handleValuationTypeChange = (event) => {
    setValuationType(event.target.value);
  };

  const [result, setResult] = useState("");
  const navigate = useNavigate();
  const [showSuccessBanner, setShowSuccessBanner] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");

    const formData = new FormData(event.target);
    const selectedLocations = locations
      .filter((location) => location.selected)
      .map((location) => location.name);

    if (selectedLocations.length > 0) {
      formData.set("Locations", selectedLocations.join(", "));
    }

    let selectedApiKey = API_KEYS.sales;
    if (valuationType === "Residential Lettings") {
      selectedApiKey = API_KEYS.lettings;
    }

    formData.append("access_key", selectedApiKey);

    const firstName = formData.get("name");
    const lastName = formData.get("surname");
    const subject = `${valuationType} - Register | ${firstName} ${lastName}`;
    formData.append("subject", subject);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setResult("Form Submitted Successfully");
        event.target.reset();
        setShowSuccessBanner(true);
        setTimeout(() => {
          setShowSuccessBanner(false);
          navigate("/");
        }, 2000);
      } else {
        setResult(`Error: ${data.message}`);
      }
    } catch (error) {
      setResult("There was an error submitting your form. Please try again.");
    }
  };

  return (
    <div className="registerContainer">
      {showSuccessBanner && (
        <div className="success-banner">
          ✅ Form Submitted Successfully! Redirecting...
        </div>
      )}
      <Navigation linkColor="black" submenuColor="black" menuIconColor="black"/>
      <Banner
        title="Register with Zen Homes"
        backgroundImage={EstateBuilding}
      />
      <div className="formRegisterContainer">
        <form className="registerForm" onSubmit={onSubmit}>
          <div className="topPartForm">
            <h1 className="formTitle">Your Details</h1>
            <select className="detailsInfo" aria-label="Title" name="Title">
              <option value="">Title</option>
              <option value="Mr">Mr</option>
              <option value="Miss">Miss</option>
              <option value="Ms">Ms</option>
              <option value="Mrs">Mrs</option>
              <option value="Dr">Dr</option>
            </select>
            <input
              type="text"
              className="input"
              placeholder="First Name"
              aria-label="First Name"
              name="name"
              required
            />
            <input
              type="text"
              className="input"
              placeholder="Surname"
              aria-label="Surname"
              name="surname"
              required
            />
          </div>

          <h1 className="formTitle">Contact Details</h1>
          <div className="secondPartForm">
            <div className="firstColumn">
              <h6 className="subtitle">Address</h6>
              <input
                type="text"
                className="input"
                placeholder="House Number"
                aria-label="House Number"
                name="House Number"
              />
              <input
                type="text"
                className="input"
                placeholder="Address Line 1"
                aria-label="Address Line 1"
                name="Address Line 1"
                required
              />
              <input
                type="text"
                className="input"
                placeholder="Address Line 2"
                aria-label="Address Line 2"
                name="Address Line 2"
              />
              <input
                type="text"
                className="input"
                placeholder="Address Line 3 (Optional)"
                aria-label="Address Line 3"
                name="Address Line 3"
              />
              <input
                type="text"
                className="input"
                placeholder="Town"
                aria-label="Town"
                name="Town"
                required
              />
              <input
                type="text"
                className="input"
                placeholder="County"
                aria-label="County"
                name="County"
              />
              <input
                type="text"
                className="input"
                placeholder="Postcode"
                aria-label="Postcode"
                name="Postcode"
                required
              />
            </div>
            <div className="secondColumn">
              <h6 className="subtitle">Telephone/Email</h6>
              <input
                type="text"
                className="input"
                placeholder="Telephone"
                aria-label="Telephone"
                name="Telephone"
              />
              <input
                type="text"
                className="input"
                placeholder="Mobile Number"
                aria-label="Mobile Number"
                name="Mobile Number"
              />
              <input
                type="text"
                className="input"
                placeholder="Work Number"
                aria-label="Work Number"
                name="Work Number"
              />
              <input
                type="email"
                className="input"
                placeholder="Email Address"
                aria-label="Email Address"
                name="Email Address"
                required
              />
            </div>
          </div>

          <h1 className="formTitle">Property Location</h1>
          <div className="locationChecklist">
            {locations.map((location, index) => (
              <label key={index} className="container">
                {location.name}
                <input
                  type="checkbox"
                  checked={location.selected}
                  onChange={() => handleLocationChange(index)}
                  name="Locations"
                />
                <span className="checkmark"></span>
              </label>
            ))}
          </div>
          <button
            type="button"
            className="locationButton"
            onClick={selectAllLocations}
          >
            Select All Locations
          </button>

          <h1 className="formTitle">General Information</h1>
          <select
            className="departmentInfo"
            aria-label="Title"
            onChange={handleValuationTypeChange}
            name="Department"
          >
            <option value="">Select Department</option>
            <option value="Residential Sales">Residential Sales</option>
            <option value="Residential Lettings">Residential Lettings</option>
          </select>
          <select
            className="departmentInfo"
            aria-label="Title"
            name="Building Type"
          >
            <option value="">Choose Type</option>
            <option value="House">House</option>
            <option value="Flat/Apartment">Flat/Apartments</option>
            <option value="Bungalow">Bungalow</option>
            <option value="Maisonette">Maisonette</option>
          </select>
          <input
            type="number"
            className="input"
            placeholder="Prices from"
            aria-label="Prices from"
            name="Min Price"
          />
          <input
            type="number"
            className="input"
            placeholder="Prices To"
            aria-label="Prices To"
            name="Max Price"
          />
          <select className="bedInfo" aria-label="Title" name="Bedrooms">
            <option value="">Min Beds</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
          </select>

          <h1 className="formTitle">Additional Information</h1>
          <textarea
            id="additional"
            name="additional information"
            rows="10"
            cols="150"
          />

          <div className="h-captcha" data-captcha="true"></div>

          <div className="btnContainer">
            <button className="submitBtn">Submit</button>
          </div>
        </form>
        <div>{result}</div>
      </div>
      <Footer />
    </div>
  );
}

export default Register;
